import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsInfo.vue?vue&type=template&id=0db274aa&scoped=true&"
import script from "./MonthAllowancesPlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db274aa",
  null
  
)

export default component.exports